import { render, staticRenderFns } from "./AreaDictionary.vue?vue&type=template&id=b8ad82ca&scoped=true"
import script from "./AreaDictionary.vue?vue&type=script&lang=js"
export * from "./AreaDictionary.vue?vue&type=script&lang=js"
import style0 from "./AreaDictionary.vue?vue&type=style&index=0&id=b8ad82ca&prod&lang=stylus&scoped=true"
import style1 from "./AreaDictionary.vue?vue&type=style&index=1&id=b8ad82ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ad82ca",
  null
  
)

export default component.exports